// Google Calendar as a read-only content connection. Standard code flow against the same
// Google OAuth client login uses, but on its own callback (/auth/google-calendar) and with its
// own narrow scope, so it never mixes with the login/YouTube/Drive flows on /auth/google.
// The client id comes from the backend, like Notion's.
export const GOOGLE_CALENDAR_AUTH_STATE_STORAGE_KEY = 'google_calendar_auth_state' as const
export type GoogleCalendarAuthState = { rnd: string; referrerPath: string }

export const GOOGLE_CALENDAR_REDIRECT_PATH = '/auth/google-calendar'

const SCOPES = ['openid', 'email', 'https://www.googleapis.com/auth/calendar.readonly']

export const startGoogleCalendarAuth = (opts: { clientId: string; referrerPath: string }) => {
  const state: GoogleCalendarAuthState = {
    referrerPath: opts.referrerPath,
    rnd: crypto.randomUUID(),
  }
  localStorage.setItem(GOOGLE_CALENDAR_AUTH_STATE_STORAGE_KEY, JSON.stringify(state))

  const url = new URL('https://accounts.google.com/o/oauth2/v2/auth')
  url.searchParams.set('client_id', opts.clientId)
  url.searchParams.set('response_type', 'code')
  url.searchParams.set('redirect_uri', `${window.location.origin}${GOOGLE_CALENDAR_REDIRECT_PATH}`)
  url.searchParams.set('scope', SCOPES.join(' '))
  // Offline + forced consent is what makes Google hand back a refresh token every time,
  // including on a reconnect of an account that already granted access once.
  url.searchParams.set('access_type', 'offline')
  url.searchParams.set('prompt', 'consent select_account')
  // Keep this grant to exactly the calendar scope, not whatever YouTube/Drive were granted.
  url.searchParams.set('include_granted_scopes', 'false')
  url.searchParams.set('state', JSON.stringify(state))
  window.location.href = url.toString()
}
